import { modals } from '@mantine/modals';
import { useEffect, useRef } from 'react';

import { useMarkDemoPopupSeen } from 'src/Hooks/Mutations/useMarkDemoPopupSeen';
import useFetchUser from 'src/Hooks/Queries/useFetchUser';
import {
  trackDemoPopupBookingClicked,
  trackDemoPopupShown,
  trackDemoPopupSkipped,
} from 'src/Services/Mixpanel/events';

export const useFirstLoginDemoPopup = () => {
  const { data: user } = useFetchUser();
  const { mutate: markSeen } = useMarkDemoPopupSeen();
  const openedRef = useRef(false);

  useEffect(() => {
    if (!user) return;
    if (user.hasSeenDemoPopup) return;
    if (openedRef.current) return;

    openedRef.current = true;
    trackDemoPopupShown();

    modals.openContextModal({
      modal: 'bookDemo',
      withCloseButton: false,
      closeOnClickOutside: false,
      closeOnEscape: false,
      size: 'lg',
      centered: true,
      innerProps: {
        onBook: () => {
          trackDemoPopupBookingClicked();
          markSeen();
        },
        onSkip: () => {
          trackDemoPopupSkipped();
          markSeen();
        },
      },
    });
  }, [user, markSeen]);
};
